export default __webpack_public_path__ + "static/media/login.01f34f9d.svg";